var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInvoiceDownload(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13029_19605)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.92581 2.003V2L20.9238 2C21.4758 2 21.9258 2.455 21.9258 2.992L21.9258 21.008C21.9255 21.2712 21.8208 21.5235 21.6346 21.7095C21.4484 21.8955 21.196 22 20.9328 22L4.91881 22C4.78748 21.9991 4.65763 21.9723 4.53665 21.9212C4.41568 21.8701 4.30595 21.7957 4.21374 21.7022C4.12153 21.6087 4.04865 21.4979 3.99924 21.3762C3.94984 21.2545 3.92488 21.1243 3.92581 20.993L3.92581 8L9.92581 2.003ZM6.75581 8H9.92581V4.83L6.75581 8ZM11.9258 4L11.9258 9C11.9258 9.26522 11.8204 9.51957 11.6329 9.70711C11.4454 9.89464 11.191 10 10.9258 10L5.92581 10L5.92581 20L19.9258 20L19.9258 4L11.9258 4Z",
    fill: "#EB4E20"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4259 10V13.5858L15.7188 12.2929L17.133 13.7071L13.4259 17.4142L9.71875 13.7071L11.133 12.2929L12.4259 13.5858V10H14.4259Z",
    fill: "#EB4E20"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13029_19605"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.925781)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoiceDownload);
export default __webpack_public_path__ + "static/media/invoiceDownload.6fdc58797c621c58b17450e162a52e8d.svg";
export { ForwardRef as ReactComponent };